import React from 'react';
import { Component } from 'reflux';
import { actions } from 'actions';
import { Panel } from 'widgets/default/panel';
import { Header } from 'widgets/default/Header';
import { PanelBody } from 'widgets/default/panel/body';
import { PanelFooter } from 'widgets/default/panel/footer';
import { Quality } from './Quality';
import { SupplierAttributeStore } from 'stores/SupplierAttributeStore';

class RatingWidget extends Component {
  state = {
    autoDeliveryRating: false,
    ratingAttributes: [],
    saveTimeOut: 2000
  }

  constructor(props) {
    super(props);

    this.mapStoreToState(SupplierAttributeStore, this.ratingChanged);
    this.mapStoreToState(SupplierAttributeStore, this.allowAutoChanged);
  }

  ratingChanged = (data) => {
    if (data.attributeKey != 'rating') {
      return;
    }

    return { ratingAttributes: Array.isArray(data) ? data : [data] };
  }

  componentWillMount() {
    const { supplier: { uid: supplierId } } = this.props;

    actions.getSupplierAttribute(supplierId, 'rating');
    actions.getSupplierAttribute(supplierId, 'autodeliveryrating');
  }

  componentDidUpdate(prevProps, prevState) {
    const { supplier: { uid: supplierId } } = this.props;

    if (JSON.stringify(prevState) !== JSON.stringify(this.state)) {
      actions.getSupplierAttribute(supplierId, 'rating');
    }
  }

  allowAutoChanged = ({ attributeKey, value }) => {
    if (attributeKey != 'autodeliveryrating') {
      return;
    }

    return { autoDeliveryRating: (parseInt(value, 10) == 5) };
  }

  setSaved() {
    this.setState({saved: true});
    setTimeout(this.unsetSaved, this.state.saveTimeOut);
  }

  unsetSaved = () => {
    this.setState({saved: false});
  }

  saveRating = (id, obj) => {
    const { supplier: { uid: supplierId } } = this.props;

    obj['id'] = id;
    actions.saveSupplierAttribute(supplierId, 'rating', obj);
    this.setSaved();
  }

  setAutoDeliveryRating = (evt) => {
    const { supplier: { uid: supplierId } } = this.props;

    const value = evt.currentTarget.checked ? 5 : 0;
    actions.saveSupplierAttribute(supplierId, 'autodeliveryrating', { value });
  }

  render() {
    var floatStyle = {float: "left", paddingBottom: '3px', width: "14%"};
    return (
      <Panel>
        <Header title="Rating" onSave={this.handleSave} saved={this.state.saved} />
        <PanelBody>
          {Array.isArray(this.state.ratingAttributes) && this.state.ratingAttributes.map((item) => (
            <Quality key={item.id} saveRating={this.saveRating} ratingObject={item} />
          ))}
        </PanelBody>
        <PanelFooter>
          <div className="clearfix">
            <div className="checkbox pull-right">
              <label style={{minHeight: 0}}>
                <input type="checkbox" onChange={this.setAutoDeliveryRating} checked={this.state.autoDeliveryRating} style={{width: "auto", marginTop: -3}} /> 
                Allow auto-delivery
              </label>
            </div>
          </div>
        </PanelFooter>
      </Panel>
    );
  }
}

export { RatingWidget };
